/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1RoleEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_ROLE_EVENT_ENTITY_NAME = 'ixm.userauth.v1.RoleEvent';
export const ixmUserauthV1RoleEventEntity = new schema.Entity<IxmUserauthV1RoleEvent>(IXM_USERAUTH_V1_ROLE_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxmUserauthV1RoleEvent) => `${entity.metadata?.eventId}` });

